import { Link } from "react-router-dom";
import { LuGraduationCap, LuTrophy, LuSun, LuScale, LuSmile, LuUsers, LuHeartHandshake, LuMail, LuPhone, LuMapPin, LuArrowRight } from "react-icons/lu";
import "../../styles/club/club.css";


const CLUB_FIGURES = [
  { number: "140", label: "Adhérents" },
  { number: "4", label: "Équipes proxy" },
  { number: "6", label: "Équipes loisir" },
  { number: "4", label: "Tournois organisés par an" },
];

const CLUB_HIGHLIGHTS = [
  {
    icon: LuGraduationCap,
    tone: "green",
    title: "Une école de volley",
    text: "Relancée en 2016 pour faire découvrir le volley aux jeunes de la côte basque, avec le soutien du Comité départemental et l’encadrement d’Éric Brouette, diplômé d’État FFVB.",
  },
  {
    icon: LuTrophy,
    tone: "red",
    title: "Des équipes en championnat",
    text: "Plus d’une centaine d’adhérents engagés en championnats Proxy et Région, et dans le championnat BLVB (Basco-Lande Volley-Ball).",
  },
  {
    icon: LuSun,
    tone: "sand",
    title: "Des tournois ouverts à tous",
    text: "Plusieurs tournois chaque année, dont le fameux tournoi de beach-volley 3x3 des fêtes de Saint-Jean-de-Luz, qui rassemble chaque année plus de 30 équipes.",
  },
];

const FFVB_VALUES = ["Respect", "Intégrité", "Solidarité", "Loyauté"];

const CLUB_VALUES = [
  { icon: LuScale, title: "Égalité", text: "Sur les terrains du VBLC, tous les joueurs sont égaux, quelles que soient leurs qualités." },
  { icon: LuSmile, title: "Plaisir du jeu", text: "Gagner ou perdre un match : le plus important est de prendre du plaisir à jouer." },
  { icon: LuUsers, title: "Esprit d’équipe", text: "Chaque joueur apporte ses qualités et ses performances pour faire avancer l’équipe." },
  { icon: LuHeartHandshake, title: "Partage", text: "Chacun est encouragé à conseiller les autres et à partager ses techniques." },
];

const OFFICE_MEMBERS = [
  { position: "Président", memberName: "Francis Milhau", email: "vblc.president@free.fr", mobile: "+33679249150" },
  { position: "Vice-président", memberName: "Charles Granger-Veyron", email: "charles.granger-veyron@hotmail.fr", mobile: "+33679761367" },
  { position: "Secrétaire", memberName: "Francis Munos", email: "francismounos@sfr.fr", mobile: "+33613412783" },
  { position: "Vice-secrétaire", memberName: "Sébastien Beaufort", email: "sebastienbeaufort64@gmail.com", mobile: "+33782748875" },
  { position: "Trésorière", memberName: "Sophie Casanova-Beaufort", email: "sophie-casanova@orange.fr", mobile: "+33675721799" },
  { position: "Responsable Sponsor", memberName: "Cyril Bernard", email: "cyrilbernard78@gmail.com", mobile: "+33698182775" },
  { position: "Responsable évènement", memberName: "Cassandre Durand", email: "cassandredurandpro@outlook.fr", mobile: "+33766422741" },
];

//INITIALES AFFICHÉES DANS L'AVATAR (ex. "Charles Granger-Veyron" -> "CG")
const getInitials = (fullName) => fullName
  .split(" ")
  .map((word) => word.charAt(0))
  .slice(0, 2)
  .join("")
  .toUpperCase();


function Club() {

  return (
    <main className="club">

      {/* EN-TÊTE */}
      <header className="page-hero">
        <img className="page-hero_img" src="/images/photoGroupe2017VBLC169.jpg" alt="" />
        <div className="wrap page-hero_content">
          <p className="page-hero_eyebrow">
            <span className="tricolor" aria-hidden="true"><span></span><span></span><span></span></span>
            Le club
          </p>
          <h1 className="page-hero_title">Volley-Ball Luzien Cibourien</h1>
          <p className="page-hero_text">Le club de volley-ball et de beach-volley de Saint-Jean-de-Luz et de Ciboure depuis plus de 30 ans.</p>
        </div>
      </header>

      {/* CHIFFRES */}
      <div className="wrap">
        <ul className="figures surface">
          {CLUB_FIGURES.map((figure) => (
            <li key={figure.label} className="figure">
              <span className="figure_number">{figure.number}</span>
              <span className="figure_label">{figure.label}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* HISTOIRE */}
      <section className="section" aria-labelledby="history-title">
        <div className="wrap club_history">
          <div className="club_history_intro">
            <p className="eyebrow">Notre histoire</p>
            <h2 id="history-title" className="title-xl">Plus de 30 ans de volley sur la côte basque</h2>
            <p className="club_lead">
              Le VBLC, Volley-Ball Luzien Cibourien, est le club de volley-ball et de beach-volley de Saint-Jean-de-Luz et de Ciboure. Créé il y a plus de 30 ans, il est devenu au fil des années l’un des clubs de volley-ball et de beach-volley les plus dynamiques de la côte.
            </p>
            <p className="club_callout">
              Jeunes ou moins jeunes, confirmés ou débutants ? Que vous ayez envie de vous engager dans un championnat ou simplement de vous initier au volley-ball ou au beach-volley, venez nous rejoindre !
            </p>
          </div>
          <ul className="club_highlights">
            {CLUB_HIGHLIGHTS.map(({ icon: Icon, tone, title, text }) => (
              <li key={title} className="club_highlight surface">
                <span className={`icon-tile icon-tile--${tone}`} aria-hidden="true"><Icon /></span>
                <div>
                  <h3 className="title-md">{title}</h3>
                  <p className="club_highlight_text">{text}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* VALEURS */}
      <section className="section section--white" aria-labelledby="values-title">
        <div className="wrap">
          <div className="section_header">
            <div className="section_heading">
              <p className="eyebrow">Nos valeurs</p>
              <h2 id="values-title" className="title-xl">Ce qui nous rassemble</h2>
              <p className="section_intro">
                Le VBLC partage pleinement les valeurs du volley-ball portées par la FFVB, auxquelles s’ajoutent celles qui, au fil de l’histoire, ont fait du club ce qu’il est aujourd’hui.
              </p>
            </div>
          </div>

          <div className="ffvb_values">
            <span className="ffvb_values_label">Valeurs FFVB</span>
            <ul className="ffvb_values_list">
              {FFVB_VALUES.map((value) => <li key={value} className="badge">{value}</li>)}
            </ul>
          </div>

          <ul className="values_grid">
            {CLUB_VALUES.map(({ icon: Icon, title, text }, index) => (
              <li key={title} className="value_card">
                <div className="value_card_top">
                  <span className="value_card_number" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
                  <Icon className="value_card_icon" aria-hidden="true" />
                </div>
                <h3 className="title-md">{title}</h3>
                <p className="value_card_text">{text}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* BUREAU */}
      <section className="section" aria-labelledby="office-title">
        <div className="wrap">
          <div className="section_header">
            <div className="section_heading">
              <p className="eyebrow">Le bureau</p>
              <h2 id="office-title" className="title-xl">L’équipe dirigeante</h2>
            </div>
          </div>

          <ul className="office_grid">
            {OFFICE_MEMBERS.map((member) => (
              <li key={member.memberName} className="member_card surface">
                <span className="member_avatar" aria-hidden="true">{getInitials(member.memberName)}</span>
                <div className="member_identity">
                  <p className="member_position">{member.position}</p>
                  <h3 className="member_name">{member.memberName}</h3>
                </div>
                <div className="member_actions">
                  <a className="member_action" href={`mailto:${member.email}`} aria-label={`Écrire à ${member.memberName}`}>
                    <LuMail aria-hidden="true" /> E-mail
                  </a>
                  <a className="member_action" href={`tel:${member.mobile}`} aria-label={`Appeler ${member.memberName}`}>
                    <LuPhone aria-hidden="true" /> Appeler
                  </a>
                </div>
              </li>
            ))}

            {/* SIÈGE SOCIAL */}
            <li className="member_card member_card--address">
              <span className="icon-tile icon-tile--red" aria-hidden="true"><LuMapPin /></span>
              <div className="member_identity">
                <p className="member_position">Siège social</p>
                <address className="member_address">9 avenue Bordaberry<br />64500 Saint-Jean-de-Luz</address>
              </div>
              <Link to="/contact" className="link-arrow">Nous contacter <LuArrowRight aria-hidden="true" /></Link>
            </li>
          </ul>
        </div>
      </section>

      {/* APPEL À L'INSCRIPTION */}
      <section className="wrap section section--flush-top">
        <div className="join_band">
          <div className="join_band_text">
            <h2 className="join_band_title">Envie de rejoindre l’aventure ?</h2>
            <p>Inscription en ligne, pas à pas. Licence, tarifs et certificat médical : toutes les infos au même endroit.</p>
          </div>
          <div className="join_band_actions">
            <Link to="/registration" className="btn btn--light btn--lg">Je m’inscris</Link>
            <Link to="/registrationHelp" className="btn btn--outline-light btn--lg">Guide d’inscription</Link>
          </div>
        </div>
      </section>
    </main>
  )
};

export default Club;
